import React, { useState } from "react";
import SearchInputButton from "./SearchInputButton.js";
// import TableComponent from "./TableComponent.js";
import DatePickerAndButtons from "./DatePickerAndButtons.js";
import DailyTableComponent from "./DailyTableComponent.js";
import MonthlyTablyComponent from "./MonthlyTableComponent.js";
import { FormControl, Select,InputLabel, MenuItem } from "@mui/material";
import {
  Box,
  Container,
  Typography,
  CardHeader,
  TextField,
  InputAdornment,
  Button,
  ButtonGroup,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CalendarIcon } from "@mui/x-date-pickers";
import CustomTabs from "../common/custom-tabs.jsx";
import AppDatePicker from "../common/app-date-picker.jsx";
import TableSearchInput from "./TableSearchInput.js";
import typography from "../cssUtils/typography.js";

export default function FileUploadData({ refreshKey }) {
  const [searchValue, setSearchValue] = useState("");
  const [holdings, setHoldings] = useState(0);
  const [dateValue, setDateValue] = useState(null);

  const [charCount, setCharCount] = useState(0);
  const [assetClass, setAssetClass] = useState("");
  const [gainLoss, setGainLoss] = useState("");

  const updateSearchValue = (value) => {
    if (value.length > 50) {
      return;
    }
    setSearchValue(value);
    setCharCount(value.length);
  };

  const updateDateValue = (value) => {
    setDateValue(value);
  };

  const updateHoldingType = (value) => {
    setHoldings(value);
  };

  return (
    <div>
      <Container maxWidth={false} sx={{ mt: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse", md: "row" },
            alignItems: "center",
            mb: 2,
            gap: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "center" },
              gap: { xs: 0, md: 2 },
              width: "100%",
            }}
          >
            <Box sx={{ maxWidth: 300, width: "100%" }}>
              <TableSearchInput
                searchQuery={searchValue}
                onSearchChange={(e) => updateSearchValue(e.target.value)}
                tooltip="Search by Client Code, Client Name, Phone, PAN or Scheme Name"
                placeholder="Search by Client Code, Name, Phone, PAN or Scheme"
                charCount={charCount}
              />
            </Box>

            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="en-gb"
            >
              <FormControl sx={{ minWidth: 160 }}>
                <InputLabel sx={typography.bodySmall}>Asset Type</InputLabel>
                <Select
                  size="small"
                  value={assetClass}
                  label="Asset Type"
                  onChange={(e) => setAssetClass(e.target.value)}
                  sx={{
                    "& .MuiSelect-select": {
                      ...typography.bodySmall,
                      display: "flex",
                      alignItems: "center",
                      minHeight: "40px !important",
                      paddingTop: "0 !important",
                      paddingBottom: "0 !important",
                    },
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="Equity">Equity</MenuItem>
                  <MenuItem value="Debt">Debt</MenuItem>
                  <MenuItem value="Hybrid">Hybrid</MenuItem>
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 160 }}>
                <InputLabel sx={typography.bodySmall}>Gain/Loss</InputLabel>
                <Select
                  size="small"
                  value={gainLoss}
                  label="Gain/Loss"
                  onChange={(e) => setGainLoss(e.target.value)}
                  sx={{
                    "& .MuiSelect-select": {
                      ...typography.bodySmall,
                      display: "flex",
                      alignItems: "center",
                      minHeight: "40px !important",
                      paddingTop: "0 !important",
                      paddingBottom: "0 !important",
                    },
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="gain">Gain</MenuItem>
                  <MenuItem value="loss">Loss</MenuItem>
                </Select>
              </FormControl>

              <AppDatePicker
                value={dateValue}
                onChange={(newValue) => updateDateValue(newValue)}
                views={["year", "month", "day"]}
                openTo="day"
                closeOnSelect
                format="DD/MM/YYYY"
                label={holdings === 0 ? "Latest Holdings Date" : "Latest Value Date"}
                placeholder="DD/MM/YYYY"
                fullWidth
                slotProps={{
                  field: { clearable: true },
                  textField: {
                    InputLabelProps: {
                      shrink: true,
                      sx: { color: "#1976d2" },
                    },
                  },
                }}
                sx={{ maxWidth: 220 }}
              />
            </LocalizationProvider>
          </Box>

          <Box sx={{ marginLeft: "auto" }}>
            <CustomTabs
              value={holdings}
              onChange={(event, newValue) => updateHoldingType(newValue)}
              tabs={[
                { label: "Daily", value: 0 },
                { label: "Monthly", value: 1 },
              ]}
            />
          </Box>
        </Box>

        {holdings === 0 ? (
          <DailyTableComponent
            searchInput={searchValue}
            key={refreshKey}
            dateInput={dateValue}
            assetClass={assetClass}
            gainLoss={gainLoss}
          />
        ) : (
          <MonthlyTablyComponent
            searchInput={searchValue}
            key={refreshKey}
            dateInput={dateValue}
          />
        )}
      </Container>
    </div>
  );
}
